import { SelectableOption } from '../submodules/angular-ui-common/base-types';

/**
 * File richiesto dal modulo angular-ui-common per le configurazioni di progetto
 */

/**
 * I locale previsti dalla specifica applicazione
 */
export const locales: SelectableOption[] = [
    { id: 'it-IT', shortLabel: 'IT', label: 'Italiano' },
    //{ id: 'en-US', shortLabel: 'EN', label: 'English' },
    //{ id: 'ar-AE', shortLabel: 'AR', label: 'العربية' }
]
